// import { useNavigate } from 'react-router-dom';
// import { getMediaURL, formatDate } from '../../utils/helpers';
// import { URL_ENDPOINTS } from '../../config/constants';
// const PostCard = ({ post }) => {
//     const navigate = useNavigate();
//     const imageUrl = getMediaURL(post.image);

//     const handleClick = () => {
//         // Use documentId instead of id for Strapi v5
//         navigate(`/${URL_ENDPOINTS.POSTS}/${post.slug}`);
//     };

//     // Strip markdown syntax and truncate
//     const getPlainTextDescription = (markdown, maxLength = 150) => {
//         if (!markdown) return '';

//         // Remove markdown syntax
//         let plainText = markdown
//             .replace(/[#*`~_\[\]()]/g, '') // Remove common markdown chars
//             .replace(/!\[.*?\]\(.*?\)/g, '') // Remove images
//             .replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1') // Convert links to text
//             .replace(/^[-*+]\s+/gm, '') // Remove list markers
//             .replace(/^\d+\.\s+/gm, '') // Remove numbered lists
//             .replace(/\n+/g, ' ') // Replace newlines with spaces
//             .trim();

//         // Truncate
//         if (plainText.length > maxLength) {
//             return plainText.substring(0, maxLength).trim() + '...';
//         }

//         return plainText;
//     };

//     return (
//         <div
//             className="group border border-gray-200 rounded-xl overflow-hidden mb-4 transition-all duration-300 cursor-pointer bg-white hover:shadow-xl hover:-translate-y-0.5 md:mb-5"
//             onClick={handleClick}
//         >
//             {imageUrl && (
//                 <div className="relative overflow-hidden aspect-[16/9]">
//                     <img
//                         src={Array.isArray(imageUrl) ? imageUrl[0] : imageUrl}
//                         alt={post.title}
//                         className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
//                     />
//                 </div>
//             )}
//             <div className="p-5 flex flex-col h-[180px]">
//                 <div className="flex-grow">
//                     <h3 className="text-lg font-bold mb-2 text-gray-900 line-clamp-2 group-hover:text-blue-600 transition-colors">
//                         {post.title}
//                     </h3>
//                     <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">
//                         {getPlainTextDescription(post.description, 150)}
//                     </p>
//                 </div>
//                 {post.publishedAt && (
//                     <p className="text-xs text-gray-400 mt-3 pt-3 border-t border-gray-100">
//                         {formatDate(post.publishedAt)}
//                     </p>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default PostCard;





import { useNavigate } from 'react-router-dom';
import { getMediaURL, formatDate } from '../../utils/helpers';
import { URL_ENDPOINTS } from '../../config/constants';
import { toTurkishDate } from '../../utils/dateConvertToTr'

const PostCard = ({ post }) => {
    const navigate = useNavigate();
    const imageUrl = getMediaURL(post.image) || '/placeholder_hor.jpg';

    const handleClick = () => {
        navigate(`/${URL_ENDPOINTS.POSTS}/${post.slug}`);
    };

    const getPlainTextDescription = (markdown, maxLength = 150) => {
        if (!markdown) return '';

        let plainText = markdown
            .replace(/[#*`~_\[\]()]/g, '')
            .replace(/!\[.*?\]\(.*?\)/g, '')
            .replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1')
            .replace(/^[-*+]\s+/gm, '')
            .replace(/^\d+\.\s+/gm, '')
            .replace(/\n+/g, ' ')
            .trim();

        return plainText.length > maxLength
            ? plainText.substring(0, maxLength).trim() + '...'
            : plainText;
    };

    return (
        <div
            className="group border border-gray-200 rounded-xl overflow-hidden mb-4 transition-all duration-300 cursor-pointer bg-white hover:shadow-xl hover:-translate-y-0.5 md:mb-5"
            onClick={handleClick}
        >
            {imageUrl && (
                <div className="relative overflow-hidden aspect-[16/9]">
                    <img
                        src={Array.isArray(imageUrl) ? imageUrl[0] : imageUrl}
                        alt={post.title}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                </div>
            )}

            <div className="p-5 flex flex-col h-[180px]">

                {/* Title (never shrinks) */}
                <h3 className="text-lg font-bold mb-2 text-gray-900 line-clamp-2 shrink-0 group-hover:text-blue-600 transition-colors">
                    {post.title}
                </h3>

                {/* Description wrapper (can shrink, prevents overflow into date) */}
                <div className="flex-grow min-h-0 pb-2 overflow-hidden">
                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-2 md:line-clamp-3 overflow-hidden">
                        {getPlainTextDescription(post.description, 120)}
                    </p>
                </div>

                {/* Date (always visible, fixed space) */}
                {post.publishedAt && (
                    <p className="text-xs text-gray-400 pt-3 mt-auto border-t border-gray-100 h-[28px] shrink-0 bg-white relative z-10">
                        {toTurkishDate(post.publishedAt)}
                    </p>
                )}
            </div>
        </div>
    );
};

export default PostCard;
